document.addEventListener("shopify:section:load", initCommunityMt);
document.addEventListener("DOMContentLoaded", initCommunityMt);

function getAverageColor(imgSrc) {
  return new Promise((resolve, reject) => {
    if (!imgSrc) {
      reject(new Error("getAverageColor requires an image URL"));
      return;
    }

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("Canvas 2D context unavailable"));
        return;
      }

      canvas.width = 1;
      canvas.height = 1;
      context.drawImage(img, 0, 0, 1, 1);

      const pixelData = context.getImageData(0, 0, 1, 1).data;
      const r = pixelData[0];
      const g = pixelData[1];
      const b = pixelData[2];

      resolve(`rgb(${r}, ${g}, ${b})`);
    };

    img.onerror = function () {
      reject(new Error(`Failed to load image: ${imgSrc}`));
    };

    img.src = imgSrc;
  });
}

function initCommunityMt() {
  initMobileNav();
  initFilters();
  initPreReqToggles();
}

function initMobileNav() {
  const mobileNav = document.querySelector("[data-mobile-nav]");
  if (!mobileNav || mobileNav.dataset.communityMtBound === "true") return;
  mobileNav.dataset.communityMtBound = "true";

  const toggle = mobileNav.querySelector(".meditations-dropdown-toggle");
  const candlesTab = mobileNav.querySelector("[data-mobile-candles-tab] .meditations-tab-label");
  const list = mobileNav.querySelector("#mobile-candle-list");
  if (!toggle || !list) return;

  function setOpen(isOpen) {
    mobileNav.classList.toggle("is-open", isOpen);
    list.hidden = !isOpen;
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  toggle.addEventListener("click", function (e) {
    e.preventDefault();
    setOpen(list.hidden);
  });

  if (candlesTab) {
    candlesTab.addEventListener("click", function () {
      const activeLink = list.querySelector(".candle-filter.active");
      const targetLink = activeLink || list.querySelector(".candle-filter");
      if (targetLink) {
        targetLink.click();
      }
      setOpen(false);
    });
  }

  mobileNav.querySelectorAll(".candle-filter").forEach((link) => {
    link.addEventListener("click", function () {
      setOpen(false);
    });
  });
}

function initFilters() {
  const filterLinks = document.querySelectorAll(".candle-filter");
  const feedContainer = document.getElementById("feed-area");
  const lockedProducts = document.getElementById("locked-products");
  const lockedCards = lockedProducts ? lockedProducts.querySelectorAll(".locked-product-card") : [];
  const cards = feedContainer ? feedContainer.querySelectorAll(".feed-card") : [];
  const purchasedHeaderRoot = document.getElementById("purchased-headers");
  const purchasedHeaderCards = purchasedHeaderRoot ? purchasedHeaderRoot.querySelectorAll(".locked-product-card.compact") : [];
  const blockedEls = document.querySelectorAll(".sj_blocked_meditations");

  if (!filterLinks.length || !feedContainer) return;

  const purchasedHandles = (window.purchasedCandles || []).filter((h) => h && h.length > 0);
  const titleRoot = document.querySelector(".meditations-title");

  function isPurchased(handle) {
    return purchasedHandles.includes(handle);
  }

  function setBlockedVisible(visible) {
    blockedEls.forEach((el) => {
      el.style.display = visible ? "flex" : "none";
      feedContainer.style.display = visible ? "block" : "none";
    });
  }

  function showLockedCard(handle) {
    if (!lockedProducts) return;
    setBlockedVisible(false);
    cards.forEach((c) => c.style.display = "none");
    if (purchasedHeaderRoot) purchasedHeaderRoot.style.display = "none";
    lockedProducts.style.display = "none";
    lockedCards.forEach((lp) => lp.style.display = "none");

    const card = lockedProducts.querySelector(`[data-handle="${handle}"]`);
    if (card) {
      lockedProducts.style.display = "block";
      card.style.display = "flex";
    }
  }

  function showFeedFor(handle) {
    setBlockedVisible(handle === "community");
    if (lockedProducts) lockedProducts.style.display = "none";
    if (purchasedHeaderRoot) {
      purchasedHeaderRoot.style.display = "none";
      purchasedHeaderCards.forEach((card) => card.style.display = "none");
    }
    if (handle !== "community" && isPurchased(handle) && purchasedHeaderRoot) {
      const header = purchasedHeaderRoot.querySelector(`[data-handle="${handle}"]`);
      if (header) {
        purchasedHeaderRoot.style.display = "block";
        header.style.display = "flex";
      }
    }
    cards.forEach((c) => c.style.display = "none");

    cards.forEach((card) => {
      const tags = card.dataset.tags || "";
      const badges = card.querySelectorAll("[data-tag-badge]");
      badges.forEach((b) => {
        b.style.display = handle === "community" ? "inline-block" : "none";
      });

      if (handle === "community") {
        card.style.display = tags.includes("community") ? "block" : "none";
        feedContainer.style.display = "block";
      } else if (tags.includes(handle)) {
        card.style.display = "block";
        feedContainer.style.display = "none";
      } else {
        card.style.display = "none";
        feedContainer.style.display = "none";
      }
    });
  }

  function scrollToTitleRoot() {
    if (titleRoot) {
      const rect = titleRoot.getBoundingClientRect();
      const offset = 16;
      window.scrollTo({ top: window.scrollY + rect.top - offset, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  function onFilterClick(e) {
    e.preventDefault();

    const handle = this.dataset.filter;
    if (!handle) return;

    filterLinks.forEach((l) => l.classList.remove("active"));
    this.classList.add("active");

    if (handle === "community") {
      showFeedFor("community");
      scrollToTitleRoot();
      return;
    }

    if (!isPurchased(handle)) {
      showLockedCard(handle);
      notifyCandleViewed(handle);
      scrollToTitleRoot();
      return;
    }

    showFeedFor(handle);
    notifyCandleViewed(handle);
    scrollToTitleRoot();
  }

  function notifyCandleViewed(handle) {
    document.dispatchEvent(new CustomEvent('sj:meditation-candle-viewed', {
      detail: { candleHandle: handle, hasAccess: isPurchased(handle) }
    }));
  }

  filterLinks.forEach((link) => {
    if (link.dataset.communityMtBound === "true") return;
    link.dataset.communityMtBound = "true";
    link.addEventListener("click", onFilterClick);
    if (link.closest(".meditations-mobile-tabs")) return;
    const img = link.querySelector("img");
    const imgSrc = (img && (img.currentSrc || img.src)) || link.dataset.img;
    const handle = link.dataset.filter;
    if (handle && handle !== "community" && !isPurchased(handle)) {
      link.style.removeProperty("--candle-bg");
      link.style.setProperty("color", `inherit`);
      return;
    }
    if (imgSrc) {
      getAverageColor(imgSrc)
        .then((color) => {
          const mixedColor = `color-mix(in srgb, ${color}, black 50%)`;
          link.style.setProperty("--candle-bg", mixedColor);
          if (handle) {
            const compactCard = document.querySelector(`#purchased-headers .locked-product-card.compact[data-handle="${handle}"]`);
            if (compactCard) compactCard.style.setProperty("--candle-bg", mixedColor);
          }
        })
        .catch(() => {});
    }
  });

  function activateFilter(handle) {
    if (!handle) return;
    const targets = document.querySelectorAll(`.candle-filter[data-filter="${handle}"]`);
    if (!targets.length) return;
    targets[0].click();
    targets.forEach((target) => target.classList.add("active"));
  }

  const params = new URLSearchParams(window.location.search);
  const requestedHandle = params.get("candle");
  if (requestedHandle) {
    activateFilter(requestedHandle);
  } else if (window.location.hash.includes("candle=")) {
    const hashHandle = window.location.hash.split("candle=")[1];
    if (hashHandle) activateFilter(decodeURIComponent(hashHandle));
  } else {
    showFeedFor("community");
    filterLinks.forEach((l) => l.classList.remove("active"));
    document.querySelectorAll('.candle-filter[data-filter="community"]').forEach((el) => {
      el.classList.add("active");
    });
  }
}

function initPreReqToggles() {
  const toggleButtons = document.querySelectorAll("[data-pre-req-toggle]");
  const filterLinks = document.querySelectorAll(".candle-filter");
  const titleRoot = document.querySelector(".meditations-title");
  const preReqContainers = () => document.querySelectorAll("[data-pre-req]");

  function setExpanded(container, isExpanded) {
    const btn = container.querySelector("[data-pre-req-toggle]");
    container.classList.toggle("is-expanded", isExpanded);
    if (btn) btn.textContent = isExpanded ? "Collapse meditation details" : "Expand meditation details";
  }

  function scrollToTop() {
    if (titleRoot) {
      titleRoot.scrollIntoView({ block: "start", behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  function scrollToContainerTop(container) {
    const card = container ? container.closest(".locked-product-card") : null;
    if (card) {
      const rect = card.getBoundingClientRect();
      window.scrollTo({ top: window.scrollY + rect.top - 16, behavior: "smooth" });
      return;
    }
    scrollToTop();
  }

  function scrollToExpanded(container) {
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const offset = 16;
    window.scrollTo({ top: window.scrollY + rect.top - offset, behavior: "smooth" });
  }

  function collapseAllPreReq() {
    preReqContainers().forEach((container) => setExpanded(container, false));
    scrollToTop();
  }

  toggleButtons.forEach((btn) => {
    if (btn.dataset.communityMtBound === "true") return;
    btn.dataset.communityMtBound = "true";
    btn.addEventListener("click", function () {
      const container = this.closest("[data-pre-req]");
      if (!container) return;
      const isExpanded = container.classList.contains("is-expanded");
      if (isExpanded) {
        setExpanded(container, false);
        scrollToContainerTop(container);
        return;
      }
      preReqContainers().forEach((other) => {
        if (other !== container) setExpanded(other, false);
      });
      setExpanded(container, true);
      scrollToExpanded(container);
    });
  });

  filterLinks.forEach((link) => {
    if (link.dataset.communityMtPreReqBound === "true") return;
    link.dataset.communityMtPreReqBound = "true";
    link.addEventListener("click", function () {
      collapseAllPreReq();
      scrollToTop();
    });
  });
}
